import { render, staticRenderFns } from "./ListadoPrecios.vue?vue&type=template&id=605ccbb8"
import script from "./ListadoPrecios.vue?vue&type=script&lang=js"
export * from "./ListadoPrecios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports